import TreeDocNode from "./TreeDocNode";
function TreeDoc({
  treeData,
  folderClicked,
  downloadDocument,
  active,
  nodeSelected,
}) {
  return (
    <ul style={{ paddingLeft: 20 }}>
      {treeData
        .sort((a, b) => a.document_name.localeCompare(b.document_name))
        .map((node) => (
          <TreeDocNode
            path={node.document_path}
            node={node}
            key={node.key}
            clickedFolder={folderClicked}
            downloadDocument={downloadDocument}
            activeFolder={active}
            sendDataToTreeDoc={nodeSelected}
          />
        ))}
    </ul>
  );
}

export default TreeDoc;
